import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export default function AppHeader() {
  const { user, isAdmin, logout } = useAuth();
  return (
    <div className="app-header">
      <Link to="/" className="app-header-home">← 返回首页</Link>
      <div className="app-header-user">
        {user ? (
          <>
            <span className="app-header-name">{user.email.split('@')[0]}</span>
            <Link to="/videos">视频</Link>
            <Link to="/account">账户</Link>
            {isAdmin && <Link to="/admin">管理</Link>}
            <button className="btn secondary" onClick={logout}>退出</button>
          </>
        ) : (
          <Link to="/login">登录</Link>
        )}
      </div>
    </div>
  );
}
